// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"772":"00e5782a","834":"42d860b9","912":"38e3ed17","966":"3b4f8fa0"}[chunkId] + ".chunk.css";
};